<template>
  <div class="appointmentList-view" :key="i18nUpdateKey">
    <div class="flex-a-b-c">
      <div class="flex-c-c">
        <el-input
          type="text"
          :placeholder="$t('business', 'assessmentRulesPlaceholder')"
          v-model="keywords"
          style="width: 200px"
          show-word-limit
        >
        </el-input>
        <el-select
          v-model="currentState"
          style="width: 240px;margin-left:20px;margin-right:20px"
          :placeholder="$t('business', 'assessmentStatusPlaceholder')"
        >
          <el-option
            v-for="(item) in stateList"
            :key="item.type"
            :label="item.state"
            :value="item.type"
          />
        </el-select>
        <el-date-picker
          class="w300"
          v-model="createTime"
          type="daterange"
          :start-placeholder="$t('business', 'assessmentStartDate')"
          :end-placeholder="$t('business', 'assessmentEndDate')">
        </el-date-picker>
        <el-button
          class="v-primary ml10"
          type="primary"
          @click="queryAppointmentPage"
          >{{ $t('business', 'assessmentQuery') }}</el-button
        >
      </div>
      
      <el-button
          class="v-primary ml10"
          type="primary"
          @click="addRules"
          >{{ $t('business', 'assessmentAdd') }}</el-button
        >
    </div>

    <commonTable
      :tableData="tableData"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
      :currentPage="currentPage"
      :loading="loading"
      :total="total"
    >
      <template v-slot:table>
        
        <el-table-column prop="kpiId" align="center" :label="$t('common', 'serialNumber')" />
        <el-table-column prop="name" show-overflow-tooltip  align="center" :label="$t('business', 'assessmentRulesName')" />
        <el-table-column width="400px" show-overflow-tooltip  align="center" :label="$t('business', 'assessmentContent')">
          <template slot-scope="scope">
            {{getRulesText(scope.row.rules)}}
          </template>
        </el-table-column>
        <el-table-column width="200px" show-overflow-tooltip align="center" :label="$t('business', 'assessmentTimeCycle')" >
          <template slot-scope="scope">
            <span>
              {{scope.row.startTime}} - {{scope.row.endTime}}
            </span>
            
          </template>
        </el-table-column>

        <el-table-column prop="status" align="center" :label="$t('business', 'assessmentStatus')">
          <template slot-scope="scope">
            <span :class="scope.row.status == 3 ? 'corange' : ''">
              {{scope.row.status == 1 ? $t('business', 'assessmentNotStarted') : scope.row.status == 2 ? $t('business', 'assessmentInProgress') : scope.row.status == 3 ? $t('business', 'assessmentEnded') : ''}}
            </span>
            
          </template>
        </el-table-column>
        <el-table-column prop="endTime" width="250" align="center" :label="$t('business', 'assessmentObject')">
          <template slot-scope="scope">
              {{getMemberText(scope.row.employees)}}
            </template>
        </el-table-column>
        <el-table-column prop="process" align="center" :label="$t('business', 'assessmentPassRate')">
          <template slot-scope="scope">
            {{scope.row.process}}%
          </template>
        </el-table-column>
        <el-table-column prop="state" align="center" :label="$t('business', 'assessmentOperation')">
          <template slot-scope="scope">
            <span
              style="cursor: pointer;margin-right:10px"
              :class="'corange'"
              @click="revocationBtn(scope.row)"
            >
              {{ $t('business', 'assessmentRevoke') }}
            </span>
            <span
              style="color: #51cbcd; cursor: pointer;margin-right:10px"
              @click="editForm(scope.row.kpiId)"
            >
              {{(scope.row.status == 3 ) ?  '' : $t('business', 'assessmentEdit')}}
            </span>
            <span
              style="color: #51cbcd; cursor: pointer;margin-right:10px"
              @click="detall_tap(scope.row.kpiId)"
            >
              {{ $t('business', 'assessmentDetail') }}
            </span>
            
          </template>
        </el-table-column>
      </template>
    </commonTable>
  </div>
</template>

<script>
import commonTable from "@/components/common/commonTable";
import { mapState } from 'vuex';
import {
  fetchProductsTypeList,
} from "@/api/companyManage.js";
import {
  employeeKpiList,
  deleteEmployeeKpi
} from "@/api/employee.js";

import { getDataTimeSec } from "@/utils";
import i18nMixin from '@/mixins/i18nMixin';

export default {
  name: "appointmentList",
  mixins: [i18nMixin],
  components: {
    commonTable,
  },
  data() {
    return {
      value: "",
      optionList: "", //全部分类
      tableData: [],
      total: 0, //总条数
      currentPage: 1, //当前页数
      queryDate: "",
      pageNum: 1,
      pageSize: 10,
      loading: false, //加载中
      createTime:'',
      start: '',
      end: '',
      jurisdiction:'',
      keywords:'',
      stateList:[],
      currentState:0
    };
  },
  computed: {
    ...mapState(['routerArr']),
    userInfo() {
      return this.$store.state.loginRoot.userInfo;
    }
  },
  watch:{
    routerArr(val){
      
      this.jurisdiction = val.includes("022")
      console.log(val.includes("022"),'this.jurisdiction')
      console.log(this.jurisdiction,'this.jurisdiction')
    },
    createTime(val,old){
      console.log(val)
      if(val){
        this.start =  getDataTimeSec(this.createTime[0], 'yy-mm-dd') +" 00:00:00"
        this.end = getDataTimeSec(this.createTime[1], 'yy-mm-dd') +" 23:59:59" 
      }else{
        this.start = ''
        this.end = ''
      }
      
    },
  },

  created() {
    // 初始化stateList，确保this.$t可用
    this.initStateList();
  },
  mounted() {
    console.log(this.userInfo)
    this.getTableData();
    this.getTypeList();
    
    // 监听语言变化，重新初始化下拉框选项
    this.$root.$on('language-changed', () => {
      this.initStateList();
    });
  },
  methods: {
    // 初始化状态列表
    initStateList() {
      this.stateList = [
        {
          type: 0,
          state: this.$t('business', 'assessmentAll')
        },
        {
          type: 1,
          state: this.$t('business', 'assessmentNotStarted')
        },
        {
          type: 2,
          state: this.$t('business', 'assessmentInProgress')
        },
        {
          type: 3,
          state: this.$t('business', 'assessmentEnded')
        }
      ];
    },
    // 获取规则文本
    getRulesText(val) {
      let text = ''
      let obj = {
        1: this.$t('business', 'assessmentAddCustomer'),
        2: this.$t('business', 'assessmentNewVisitors'),
        3: this.$t('business', 'assessmentFollowUpRate'),
        4: this.$t('business', 'assessmentSalesAmount')
      };
      val.forEach((item,index) => {
        let unit = '';
        if (item.type == 1 || item.type == 2) {
          unit = this.$t('business', 'assessmentPeople');
        } else if (item.type == 3) {
          unit = '%';
        } else if (item.type == 4) {
          unit = this.$t('common', 'yuan');
        }
        text += obj[item.type] + item.value + unit + '/';
      });
      return text
    },
    // 获取成员文本
    getMemberText(val) {
      let names =  '' 
       val.forEach((item,index)=>{
         names +=  item.nickeName+'、'
       })
       if(names.length > 15){
         names = names.slice(0,10) + '...(' +  val.length + this.$t('business', 'assessmentPeople') + ')'
       }
       return  names
    },
    //请求预约数据
    getTableData() {
      this.loading = true;
      let data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        status:this.currentState,
        keywords:this.keywords
      };
      if(this.start) data.startTime = this.start
      if(this.end) data.endTime = this.end
      employeeKpiList(data)
      .then((res) => {
        this.loading = false;
        this.tableData = res.data.pageInfo.list || "";
        this.total = res.data.pageInfo.total;
      })
      .catch((err) => {
        this.loading = false;
        this.tableData = [];
        console.log(err);
      });
    },
    //查询分类
    getTypeList() {
      fetchProductsTypeList({ ignore: true })
        .then((res) => {
          this.optionList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //筛选查询符合条件数据
    queryAppointmentPage() {
      this.currentPage = 1;
      this.pageNum = 1;
      this.getTableData();
      
    },
    //新增表单
    addRules(){
      this.$router.push(`/theInspectionRules`)
    },
    //编辑表单
    editForm(id){
      // if(this.jurisdiction || this.userInfo.roleId){
      //   console.log(this.jurisdiction,'this.jurisdiction')
        
        
      // }else{
      //   this.$message({
      //       type: "warning",
      //       message: "暂无权限",
      //     });
      //   return
      // }
      this.$router.push({ path:`/theInspectionRules?id=${id}` });
      // if(!this.userInfo.roleId){
      //   this.$message({
      //     type: "warning",
      //     message: "无操作权限",
      //   });
      //   return
      // }
      
    },
    //详情按钮
    detall_tap(id){
      // this.$router.push({
      //   name:'formDetall',
      //   params:{
      //     id:id
      //   }
      // });
      this.$router.push({ path:`/theAssessmentDetails?id=${id}` });
    },
    //筛选时间
    dateChange(val) {
      this.queryDate = getDataTimeSec(val, "yy-mm-dd");
    },
    //取消
    cancel(val) {
      
    },
    revocationBtn(val){
      this.$confirm(this.$t('business', 'assessmentConfirmRevoke'), this.$t('common', 'info'), {
        confirmButtonText: this.$t('common', 'confirm'),
        cancelButtonText: this.$t('common', 'cancel'),
      })
      .then(() => {
        let data = {
          kpiId:val.kpiId
        };
        deleteEmployeeKpi(data)
        .then(res=>{
          console.log(res)
          if(res.code == 200){
            this.$message.success(this.$t('business', 'assessmentRevokeSuccess'))
            this.getTableData()
          }
        })
      })
      .catch((err) => {
        console.log(err);
        this.$message({
          type: "info",
          message: this.$t('business', 'assessmentCancelInput'),
        });
      });
    },
    //当前页变更
    handleCurrentChange(num) {
      this.pageNum = num;
      this.getTableData();
    },
    //当前页查询数据条数变更
    handleSizeChange(num) {
      this.pageSize = num;
      this.pageNum = 1;
      this.currentPage = 1;
      this.getTableData();
    },
  },
  beforeDestroy() {
    // 清理事件监听
    this.$root.$off('language-changed');
  }
};
</script>

<style lang="scss" scoped>
.appointmentList-view {
  background: #ffffff;
  padding: 24px;
}
</style>